<!-- Copyright 2026 Midas Healthcare Solutions - All Rights Reserved -->
<ng-container *transloco="let t">
  <div class="profile-pic-dialog">
    @if (isFirstLogin) {
      <h2>{{ t('ProfilePicTitle') }}</h2>
      <div>{{ t('ProfilePicInfo') }}</div>
    }
    @if (errorMessage) {
      <mat-error>{{ errorMessage }}</mat-error>
    }
    <input
      #fileInput
      type="file"
      accept="image/*"
      hidden
      (change)="onFileSelected($event)"
    />

    <canvas #canvasEl hidden></canvas>

    @if (mode() === 'loading') {
      @if (isStartingCamera) {
        <div class="ui-loading">
          <mat-spinner diameter="100"></mat-spinner>
        </div>
      } @else {
        <div class="actions">
          <button mat-flat-button color="primary" (click)="startCamera()">{{ t('TakePhoto') }}</button>
          <button mat-flat-button color="primary" (click)="openFilePicker()">{{ t('UploadPhoto') }}</button>
          <button mat-flat-button color="primary" (click)="close()">{{ t('Cancel') }}</button>
        </div>
      }
    } @else if (mode() === 'camera') {
      <video #videoEl autoplay playsinline muted></video>
      <div class="actions">
        <button mat-flat-button color="primary" (click)="capturePhoto()">{{ t('Capture') }}</button>
        <button mat-flat-button color="primary" (click)="openFilePicker()">{{ t('UploadPhoto') }}</button>
        <button mat-flat-button color="primary" (click)="close()">{{ t('Cancel') }}</button>
      </div>
    } @else if (mode() === 'crop') {
      <div class="crop-panel">
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [imageBase64]="imageBase64"
          [maintainAspectRatio]="true"
          [aspectRatio]="1"
          [resizeToWidth]="400"
          [onlyScaleDown]="true"
          [roundCropper]="true"
          format="jpeg"
          output="blob"
          (imageCropped)="imageCropped($event)"
          (loadImageFailed)="loadImageFailed()"
        ></image-cropper>

        @if (croppedPreviewUrl) {
          <div class="preview-block">
            <div class="preview-label">{{ t('Preview') }}</div>
            <img [src]="croppedPreviewUrl" class="preview-image"/>
          </div>
        }
      </div>

      <div class="actions">
        <button
          mat-flat-button
          color="primary"
          (click)="save()"
          [disabled]="!croppedBlob || isSaving"
        >
          {{ t('Save') }}
        </button>
        <button mat-flat-button color="primary" (click)="retake()">{{ t('Retake') }}</button>
        <button mat-flat-button color="primary" (click)="openFilePicker()">{{ t('ChooseDifferentFile') }}</button>
        <button mat-flat-button color="primary" (click)="close()">{{ t('Cancel') }}</button>
      </div>
    }
  </div>
</ng-container>
